// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__33C3y","message":"CookieConsent_message__3A22_","cookieLink":"CookieConsent_cookieLink__24Hcy","continueBtn":"CookieConsent_continueBtn__3qLcf"};